<script lang="ts" setup>
import { useTeleSalesStore } from "~/projects/tele-sales/stores/teleSalesStore";
import { useDialogStore } from "~/projects/cc/stores/dialogStore";
const teleSalesStore = useTeleSalesStore();
const dialogStore = useDialogStore();

const hanldeTeleSalesDialogClose = (done: () => void) => {
  dialogStore.setTeleSaleEditDialogVisibility(false);
  done();
};
</script>

<template>
  <div class="sm:call">
    <client-only>
      <el-dialog
        v-model="dialogStore.showTeleSalesEditDialog"
        :before-close="hanldeTeleSalesDialogClose"
        :lock-scroll="false"
        :destroy-on-close="true"
        :modal="false"
        :show-close="false"
        width="35%"
        draggable
      >
        <template #header="{ titleId, titleClass }">
          <div class="my-header flex flex-col gap-1">
            <h4 :id="titleId" class="text-md" :class="titleClass">
              Update Sale Info
            </h4>
            <span class="dialog-title-subtext">
              Update the form to edit tele sale item
            </span>
          </div>
        </template>

        <div class="p-2">
          <TeleSalesEditForm
            :key="teleSalesStore.selectedTeleSaleForEdit.id"
            :show-edit-modal-header="false"
            @close="dialogStore.setTeleSaleEditDialogVisibility(false)"
          />
        </div>
      </el-dialog>
    </client-only>
  </div>
</template>

<style scoped></style>
